export default "__VITE_ASSET__BNX$C6Gp__"